import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

import { userKeys } from "./query-keys";

export function useSetUserRoles() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, roleNames }: { id: string; roleNames: string[] }) => {
      const { error } = await apiClient.PUT("/v1/admin/users/{id}/roles", {
        params: { path: { id } },
        body: { role_names: roleNames },
      });
      /* v8 ignore next -- unreachable: client errorMiddleware throws ApiError on !ok */
      if (error) throw error;
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: userKeys.all });
    },
  });
}
